// extracted by mini-css-extract-plugin
export default {"mentionsLegales":"MentionsLegales_mentionsLegales__FB45y","blockSection":"MentionsLegales_blockSection__i6NJZ"};